"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function get() {
    return _queryString.parse;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function get() {
    return _queryString.stringify;
  }
});
Object.defineProperty(exports, "buildPath", {
  enumerable: true,
  get: function get() {
    return _buildPath.buildPath;
  }
});
Object.defineProperty(exports, "setErrorClass", {
  enumerable: true,
  get: function get() {
    return _error.setErrorClass;
  }
});
Object.defineProperty(exports, "getSubdomain", {
  enumerable: true,
  get: function get() {
    return _getSubdomain.getSubdomain;
  }
});
Object.defineProperty(exports, "parseSubdomain", {
  enumerable: true,
  get: function get() {
    return _parseSubdomain.parseSubdomain;
  }
});
Object.defineProperty(exports, "urlJoin", {
  enumerable: true,
  get: function get() {
    return _urlJoin.urlJoin;
  }
});
exports.query = void 0;

var _queryString = require("./query-string");

var _buildPath = require("./build-path");

var _error = require("./error");

var _getSubdomain = require("./get-subdomain");

var _parseSubdomain = require("./parse-subdomain");

var _urlJoin = require("./url-join");

var query = {
  parse: _queryString.parse,
  stringify: _queryString.stringify
};
exports.query = query;